import React from "react";
import {FieldViewProps} from "../../../render/view";
import Reactions from "../../../../model2/reaction/reactions";
import ReactionsList from "../../../../gd-components/reactions/reactions-list/reactions-list";

// used in board

export default function FieldTReaction_ViewProperty(props: FieldViewProps) {


    const value = _.get(props.model, props.field.fieldId, null)

    const reactions = Reactions.initFromJson(value)

    return <ReactionsList className = {props.className}
                          size      = {22}
                          reactions = {reactions}
                          disabled  = {true} />

}